<template>
  <div>
    <div class="logo-containers">
      <van-row type="flex" justify="center">
        <van-col span="4"></van-col>
        <van-col span="8"><van-icon name="checked" size="60px" color="#00b949"/></van-col>
        <van-col span="4"></van-col>
      </van-row>
      <div class="gap"></div>
      <van-row type="flex" justify="center">
        <van-col span="1"></van-col>
        <van-col span="20">
          <div>
            工单已提交
          </div>
          <div class="info">
            <div>
              已将您的反馈内容提交给客服
            </div>
            <div>
              请注意接收公众号消息，关注问题解决进度
            </div>
          </div>
        </van-col>
        <van-col span="1"></van-col>
      </van-row>
    </div>
    <div class="login-input-containers">
      <div class="logo-containers">
        <van-row type="flex" justify="center">
          <van-col span="6"></van-col>
          <van-col span="12"><van-button color="#004099" type="primary" plain @click="login" block>关闭</van-button></van-col>
          <van-col span="6"></van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
import { Col, Row,Field,CellGroup,Button,Icon} from 'vant';
  export default {
    components : {
      [Row.name]:Row,
      [Col.name]:Col,
      [Field.name]:Field,
      [CellGroup.name]:CellGroup,
      [Icon.name]:Icon,
      [Button.name]:Button
    },
    mounted(){
      console.log([Row.name])
    },
    data(){
      return {
        userinfo : {
          username : '',
          password : ''
        }
      }
    },
    methods : {
      login(){
        this.$router.push({
          path : '/feedback'
        })
      }
    }
  }
</script>

<style scoped>
.logo-containers{
  padding-bottom : 60px;
  text-align : center;
  height : 105px;
  margin-top : 100px;
}
.gap{
  height : 20px;
}
.info{
  padding-top : 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/submitsucess/index.vue